/**
 * @generated SignedSource<<b6b1833dfe54d14b120a274b662c91e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TeamMemberRole = "Admin" | "Member" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FeedSchedulerInput_viewer$data = {
  readonly personQueryResultErrorable?: {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
    readonly message: string | null;
  } | {
    readonly __typename: "PersonQueryResult";
    readonly query: string;
    readonly persons: ReadonlyArray<{
      readonly id: string;
      readonly primaryEmail: string;
      readonly primaryCalendar: any;
      readonly emails: ReadonlyArray<string>;
      readonly profile: {
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
      } | null;
    } | null>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly groupQueryResult?: {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
    readonly message: string | null;
  } | {
    readonly __typename: "ExternalGroupSearchResult";
    readonly inputQuery: string;
    readonly groups: ReadonlyArray<{
      readonly emailAddress: string;
      readonly groupSize: number;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly teamQueryResultErrorable?: {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
    readonly message: string | null;
  } | {
    readonly __typename: "TeamQueryResult";
    readonly query: string;
    readonly teams: ReadonlyArray<{
      readonly teamName: string;
      readonly teamId: string;
      readonly teamRoleAndPersonIds: ReadonlyArray<{
        readonly role: TeamMemberRole;
        readonly personId: string;
      }>;
    }>;
    readonly teamMembers: ReadonlyArray<{
      readonly role: TeamMemberRole;
      readonly person: {
        readonly personId: string;
        readonly isYou: boolean;
        readonly primaryCalendarId: string;
        readonly profile: {
          readonly givenName: string | null;
          readonly familyName: string | null;
          readonly externalImageUrl: string | null;
        } | null;
      };
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "FeedSchedulerInput_viewer";
};
export type FeedSchedulerInput_viewer$key = {
  readonly " $data"?: FeedSchedulerInput_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedSchedulerInput_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "orgRelayId",
  "variableName": "orgRelayId"
},
v1 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "queryInput"
},
v2 = [
  {
    "kind": "Variable",
    "name": "excludeCalendars",
    "variableName": "excludeCalendars"
  },
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalImageUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeCalendars"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "externalGroupRefetch"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgRelayId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "queryInput"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedSchedulerInput_viewer",
  "selections": [
    {
      "condition": "externalGroupRefetch",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "personQueryResultErrorable",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "persons",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "primaryEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "primaryCalendar",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emails",
                      "storageKey": null
                    },
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "PersonQueryResult",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "groupQueryResult",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "inputQuery",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExternalGroupSearchMetadata",
                  "kind": "LinkedField",
                  "name": "groups",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailAddress",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "groupSize",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "ExternalGroupSearchResult",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "concreteType": null,
          "kind": "LinkedField",
          "name": "teamQueryResultErrorable",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "teams",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "teamName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "teamId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TeamRoleAndPersonId",
                      "kind": "LinkedField",
                      "name": "teamRoleAndPersonIds",
                      "plural": true,
                      "selections": [
                        (v7/*: any*/),
                        (v8/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TeamMember",
                  "kind": "LinkedField",
                  "name": "teamMembers",
                  "plural": true,
                  "selections": [
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrgPerson",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v8/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isYou",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "primaryCalendarId",
                          "storageKey": null
                        },
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "TeamQueryResult",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "41759858bd9ece4777d3cdc569068166";

export default node;
